<div class="flex h-full w-full flex-col items-center justify-center gap-12 bg-background">
	@if ($isCare()) {
		<img
			[src]="AgatheYouCareAssets.LOGO_COMPLET"
			class="h-48 w-48"
			alt="Logo Agathe You Care"
		/>
	} @else {
		<img
			src="/static-assets/imgs/agathe-you/logo-agathe-you.svg"
			class="h-48 w-48"
			alt="logo-404"
		/>
	}
	<span class="milo-font text-lg text-on-background">
		Tu t'es perdu ? Pas de soucis, on t'aide à retrouver ton chemin. L'accueil, c'est par ici :
	</span>
	<uikit-button
		color="filled"
		radius="full"
		(action)="goToDashboard()"
	>
		Accueil
	</uikit-button>
</div>
